export const CorporatePermissions = {
  ['download_exports']: 101n,
  ['read_controls']: 102n,
  ['write_controls']: 103n,
  ['bi_view_only']: 104n,
  ['bi_exports']: 105n,
  ['bi_explorer']: 106n,
  ['clients__corporate_merge']: 107n,
  ['pii__view_contact_details']: 108n,
  ['pii__view_full_identity']: 109n,
  ['pii__export_pii']: 110n,
  ['content__read']: 111n,
  ['content__write']: 112n,
  ['content__publish']: 113n,
  ['content__delete']: 114n,
  ['content__moderate']: 115n,
  ['content__configure_permissions']: 116n,
  ['content__view_analytics']: 117n,
} as const

export type CorporatePermissionsKey = keyof typeof CorporatePermissions
